'use strict';

angular.module(
	'core', 
	[
		'core.shop',
		'core.contacts',
		'core.faq'
	]);